import _cloneDeep from 'lodash/cloneDeep'

import {reduxCalculationAccess, reduxCalculationFeatures} from '../../helpers/common'

import {
  GET_LISTUSERS_REQUESTED,
  GET_LISTUSERS_SUCCESS,
  GET_LISTUSERS_FAILED,
  GET_CURRENTUSER_REQUESTED,
  GET_CURRENTUSER_SUCCESS,
  GET_CURRENTUSER_FAILED, GET_FEATURES_SUCCESS, GET_FEATURES,
} from '../actions/actionTypes'

const initialState = {
  listUsers: [],
  isLoading: false,
  commonError: false,
  userInfo: null,
  accessRoles: {},
  currentUserError: '',
  accessFeatures: {}
}

const userReducer = (state = _cloneDeep(initialState), action) => {
  switch (action.type) {
    case GET_LISTUSERS_REQUESTED:
      return {
        ...state,
        isLoading: true,
        commonError: false
      }
    case GET_LISTUSERS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isBack: true,
        listUsers: action.payload.users
      }
    case GET_LISTUSERS_FAILED:
      return {
        ...state,
        isLoading: false,
        commonError: action.payload
      }
    case GET_CURRENTUSER_REQUESTED:
      return {
        ...state
      }
    case GET_CURRENTUSER_SUCCESS:
      return {
        ...state,
        userInfo: action.payload,
        accessRoles: reduxCalculationAccess(action.payload.roles)
      }
    case GET_FEATURES:
      return {
        ...state,
        isLoadingConfiguration: true
      }
    case GET_FEATURES_SUCCESS:
      return {
        ...state,
        accessFeatures: reduxCalculationFeatures(action.payload.data.features),
        isLoadingConfiguration: false
      }
    case GET_CURRENTUSER_FAILED:
      return {
        ...state,
        currentUserError: action.payload
      }

    default:
      return state
  }
}

export default userReducer
